<template>
  <div class="common-banner">
    <div class="banner-content-panel" v-if="bannerContentEnable">
      <span class="banner-panel-title">
        {{ $t("提交智上悠蓝") }}，{{ $t("绘制未来") }}！
      </span>
      <span class="banner-panel-intro">
        {{ $t("AI重塑正畸生态") }}&nbsp;&nbsp;&nbsp;
        {{ $t("让医疗回归本质") }}&nbsp;&nbsp;&nbsp;
        {{ $t("与正畸医生同行") }}
      </span>
    </div>
    <!-- <div class="btn-participate-in">{{ $t("立即参与") }}</div> -->
  </div>
</template>

<script>
export default {
  name: "commonBanner",
  data() {
    return {
      bannerContentEnable: true
    };
  }
};
</script>

<style scoped>
.common-banner {
  width: 100%;
  height: 120px;
  min-width: 1440px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-image: url("/static/images/common/ico_banner_bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.banner-content-panel {
  height: 76px;
  min-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-left: 12px;
  margin-left: 32px;
}

.banner-panel-title {
  display: block;
  font-size: 24px;
  color: #123168;
  font-weight: 600;
  margin-bottom: 8px;
}

.banner-panel-intro {
  font-size: 16px;
  color: #123168;
  font-weight: 400;
  display: block;
}

.btn-participate-in {
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25px;
  background: #34556c;
  height: 46px;
  width: 112px;
  color: #fff;
  font-size: 16px;
  margin-right: 56px;
  font-weight: 500;
  letter-spacing: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/commonBanner.vue